import React from 'react';
const MapSkeleton = () => {
  return <div className='col-span-full h-[328px] animate-pulse rounded bg-gray-100 lg:col-span-6 lg:h-[370px]' data-sentry-component="MapSkeleton" data-sentry-source-file="map-skeleton.tsx" />;
};
export default MapSkeleton;